import { BrowserApi } from '@/core/apis/browser_api';
import { EBrowserStorageType } from '@/core/apis/browser_storage_api/browser_storage_api_types';

/**
 * Gets a flag value from the URL / specified storage and caches it
 * @param key Key to fetch from URL params and Storage
 * @param storageType Type of storage to store the value, LOCAL / SESSION only.
 * @returns
 */
export function retreiveAndStoreFlag(
  key: string,
  storageType: EBrowserStorageType,
) {
  if (
    storageType !== EBrowserStorageType.LOCALSTORAGE &&
    storageType !== EBrowserStorageType.SESSIONSTORAGE
  )
    throw new Error(
      'For flag storing, only local and session storage are supported',
    );

  const urlParam = BrowserApi.getUrlParam(key);
  const storage =
    storageType === EBrowserStorageType.LOCALSTORAGE
      ? localStorage
      : sessionStorage;

  if (urlParam) {
    storage.setItem(key, urlParam);
    return urlParam;
  }
  return storage.getItem(key);
}
